'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Form File File
 *
 * @class
 */

class FormFile extends Core {

    _defaults() {
        return {
            target: '.js-formFile',
            fields: {
                'title': ""
            }
        };
    }

    constructor(options) {
        super(options);

        var uniqueId = "f_"+this._options.fields.title.replace(/[^a-zA-Z0-9]/g, ""); // make unique identifier with safe css ID

        this.template = `
            <div class='editor__form__file'>
                <input id="${uniqueId}" type="file" class='editor__form__file__input js-editor__form__file__input' value='<%-title%>'>
                <label for="${uniqueId}" class="editor__form__file__label">
                    <div class='btn__txt'>Choose a file</div>
                </label>
            </div>
        `;

        super.render();

        /**
         * Click
         *
         * @fires FormFile#_change
         */

        $('.js-editor__form__file__input', this.$el).on('change', this._change);
    }

    /**
     * @event FormFile#Cioui:Form:File:click
     * @property {String}Cioui:Form:File:click
     * @returns {String} value- the new text input obj
     */

    _change(e){
        $(e.currentTarget).trigger('Cioui:Form:file:change', e);
    }

}
module.exports = FormFile;